import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import DataGrid from './data-grid';
export default class AudienceGrid extends React.Component {
  render() {
    var data = this.props.data;
    var columns = [{
      field: 'name',
      title: 'Name',
      cell: props => {
        var row = props.dataItem;
        var routeName = row.name.replace(/ /g, '@');
        var detailLink = '/Contacts/Audience/' + routeName;
        var name = row.name;
        if (!name) name = 'n/a';
        // System audiences (derived/auto-managed projections) are
        // locked: never deletable, never an import target.
        var system = ['all contacts', 'customers'].includes(String(name).toLowerCase());
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, /*#__PURE__*/React.createElement(Link, {
          to: detailLink
        }, name), system && /*#__PURE__*/React.createElement("span", {
          className: "material-icons",
          title: "System audience \u2014 managed automatically; not an import target",
          style: {
            fontSize: '14px',
            verticalAlign: 'middle',
            marginLeft: '6px',
            color: '#9aa4b2'
          }
        }, "lock")));
      }
    }, {
      field: 'audienceType',
      title: 'Type',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.audienceType));
      }
    }, {
      field: 'provider',
      title: 'Provider',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.provider));
      }
    }, {
      field: 'total',
      title: 'Size',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, row.total);
      }
    }, {
      field: 'lastRefreshDate',
      title: 'Last Updated',
      cell: props => {
        var row = props.dataItem;
        var lastUpdated = moment(row.lastRefreshDate).format('ll');
        return /*#__PURE__*/React.createElement("td", null, lastUpdated);
      }
    }];

    // Row actions — opt-in via handlers (Manage Data passes them; the
    // research/marketing consumers render the plain grid unchanged).
    // System audiences (locked) never show actions.
    if (this.props.onAddMember || this.props.onRename || this.props.onDelete) {
      columns.push({
        field: '_actions',
        title: ' ',
        sortable: false,
        width: '220px',
        cell: props => {
          var row = props.dataItem;
          var system = ['all contacts', 'customers'].includes(String(row.name || '').toLowerCase());
          if (system) return /*#__PURE__*/React.createElement("td", {
            style: {
              textAlign: 'right'
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "territory-hint",
            style: {
              margin: 0
            },
            title: "Managed automatically \u2014 membership comes from feeds and lifecycle"
          }, "system \xB7 read-only"));
          // Action links inherit the cell font size (matches the Name
          // link + every other column); Delete uses the theme danger
          // token so it stays destructive-distinct but on-palette.
          return /*#__PURE__*/React.createElement("td", {
            style: {
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }, this.props.onAddMember && /*#__PURE__*/React.createElement("a", {
            style: {
              cursor: 'pointer',
              marginRight: '12px'
            },
            onClick: () => this.props.onAddMember(row)
          }, "Add member"), this.props.onRename && /*#__PURE__*/React.createElement("a", {
            style: {
              cursor: 'pointer',
              marginRight: '12px'
            },
            onClick: () => this.props.onRename(row)
          }, "Rename"), this.props.onDelete && /*#__PURE__*/React.createElement("a", {
            style: {
              cursor: 'pointer',
              color: 'var(--plk-danger)'
            },
            onClick: () => this.props.onDelete(row)
          }, "Delete"));
        }
      });
    }
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}